// Module: instruction-text
// Role: Presentation helper for flow checkpoint copy. Flow templates often pack a
//       numbered list into one paragraph («… Загрузите 3 фото: 1) …, 2) …»);
//       split it so the miniapp renders each item on its own line.
// Uses: nothing (pure).
// Used by: MultiImageUploadBrick.tsx and its tests.

export interface InstructionParts {
  intro: string;
  items: { number: string; text: string }[];
}

export function splitInstructionText(text: string | null): InstructionParts {
  const normalized = (text ?? '').replace(/\r\n/g, '\n').trim();
  if (normalized.length === 0) return { intro: '', items: [] };
  if (normalized.includes('\n')) return { intro: normalized, items: [] };

  const parts = normalized.split(/\s+(?=\d+\)\s)/);
  const intro = parts[0]?.trim() ?? '';
  const items = parts.slice(1).flatMap((part) => {
    const match = part.match(/^(\d+)\)\s*(.+)$/);
    if (!match) return [];
    const itemText = match[2].trim().replace(/\s*[,;]$/, '');
    if (!itemText) return [];
    return [{ number: match[1], text: itemText }];
  });

  if (items.length === 0) return { intro: normalized, items: [] };
  return { intro, items };
}
